import { Component, Input, OnInit } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { GtmService } from '../../../services/gtm.service';
import { GTM_PUSH_CATEGORY_INTERRACTIONS_PAGES, GTM_PUSH_CATEGORY } from '../../../modeles/variables';
import { NgxTippyProps, NgxTippyService } from 'ngx-tippy-wrapper';

@Component({
  selector: 'app-tooltip-desktop',
  templateUrl: './tooltip-desktop.component.html',
  styleUrls: ['./tooltip-desktop.component.scss'],
  animations: [
    trigger('enterAnimation', [
      transition(':enter', [style({ opacity: 0 }), animate('180ms ease-in-out', style({ opacity: 1 }))]),
      transition(':leave', [style({ opacity: 1 }), animate('180ms ease-in-out', style({ opacity: 0 }))])
    ])
  ],
  standalone: false
})
export class TooltipDesktopComponent implements OnInit {
  @Input()
  id?: string;

  @Input()
  titre: string;

  @Input()
  texte: string;

  @Input()
  altText: string;

  @Input()
  ariaLabel: string;

  @Input() showQuestionMark: boolean;
  @Input() isCustomContent: boolean;
  @Input() isInsideText: boolean;
  @Input() placement: 'top' | 'bottom' = 'top';
  @Input() width: string;

  tippyProps: NgxTippyProps = {
    arrow: true,
    theme: 'light-border',
    allowHTML: true,
    interactive: true,
    animation: 'shift-toward',
    trigger: 'click',
    offset: [0, 10],
    zIndex: 500,
    popperOptions: {
      modifiers: [
        {
          name: 'flip',
          options: {
            // Permet de reproduire le comportement de popper.js v1
            // (préférer un placement vers le bas si le contenu overflow dans les deux directions pour les petits écrans)
            padding: { top: 100, bottom: -100 }
          }
        }
      ]
    }
  };

  constructor(private readonly _gtm: GtmService, private readonly _tippyService: NgxTippyService) {}

  ngOnInit() {
    this.tippyProps.placement = this.placement;
    this.tippyProps.maxWidth = this.width;
  }

  clickTooltip() {
    if (this.titre) {
      this._gtm.pushEvent({
        event: GTM_PUSH_CATEGORY_INTERRACTIONS_PAGES,
        category: GTM_PUSH_CATEGORY,
        label: this.titre,
        action: 'click - infobulles',
        value: 0,
        nonInteraction: false
      });
    }
  }

  closeTooltip() {
    this._tippyService.hideAll();
  }
}
